
import styles from './ua.module.scss'

export default function PanelTitle(props) {
  
  let stylesArray = [styles.headerT]
  if (props.leftPad) stylesArray.push(styles.headerTLp)
  if (props.rightPad) stylesArray.push(styles.headerTRp)
  if (props.centered) stylesArray.push(styles.headerTC)
  
  return <div className={stylesArray.join(' ')}>
    { props.children }
  </div>
  
}